<div class="flex h-full w-full">
  <mat-sidenav-container #container class="min-w-0 flex-1 !bg-transparent">
    <mat-sidenav
      [class.!-z-10]="(sidebar.isMobile$ | async) === false"
      [fixedInViewport]="true"
      [mode]="sidebar.mode$ | ngrxPush"
      [opened]="sidebar.opened$ | ngrxPush"
      (closedStart)="sidebar.close()"
    >
      <pr-sidebar
        #sidebarContainer
        (widthChange)="container.updateContentMargins()"
      >
        <pr-sidebar-items [expanded]="sidebar.expanded$ | ngrxPush" />
      </pr-sidebar>
    </mat-sidenav>

    <mat-sidenav-content class="flex-col overflow-x-hidden bg-transparent">
      <pr-toolbar
        *ngrxLet="notificationsOpen$ as notificationsOpen"
        class="fixed inset-x-0 -z-10 mt-0 bg-transparent"
        [class.is-mobile]="sidebar.isMobile$ | ngrxPush"
        [style.padding-left]="sidebarContainer.width$ | async"
        [ngClass]="{
          '!right-[360px]': managementSidebar.opened$ | async
        }"
        [chatCount]="chatCount$ | ngrxPush"
        [notificationsCount]="notificationsCount$ | ngrxPush"
        (notificationsToggle)="notificationsOpen$.next(!notificationsOpen)"
      />
      <div class="toolbar-spacer -z-50"></div>
      <div
        fxFlex
        class="overflow-hidden rounded-t-lg bg-[#fafafa] print:overflow-visible md:mx-1 md:mb-1 md:rounded-b-lg"
      >
        <pt-dynamic-sidebar>
          <pr-setup-step-banner />
          <router-outlet />
        </pt-dynamic-sidebar>
      </div>
    </mat-sidenav-content>

    <mat-sidenav
      #sidenav="matSidenav"
      mode="over"
      position="end"
      class="!bg-[#fafafa]"
      [opened]="notificationsOpen$ | ngrxPush"
      (openedChange)="notificationsOpen$.next($event)"
    >
      <ng-container *ngrxLet="notifications$ as notifications">
        <pr-notifications-sidebar
          [notifications]="notifications"
          (closed)="sidenav.close()"
        />
      </ng-container>
    </mat-sidenav>
  </mat-sidenav-container>

  @if (managementSidebar.opened$ | async) {
    <div class="h-full w-[360px] shrink-0 bg-white">
      <pt-management-tool-panel (closePanel)="managementSidebar.close()" />
    </div>
  }
</div>

<pr-popup-notifications />
